import { Action } from "../../store/types";
import { Product } from "../../models";
import * as actions from "./actions";

export interface ProductSearchState {
  searchValue: string;
  suggestions: Product[];
  isSuggestionsLoading: boolean;
  isSuggestionsShown: boolean;
}

const initState: ProductSearchState = {
  searchValue: "",
  suggestions: [],
  isSuggestionsLoading: false,
  isSuggestionsShown: false,
};

export default function(
  state = initState,
  { type, payload }: Action,
): ProductSearchState {
  switch (type) {
    case actions.SET_SEARCH_VAL:
      return { ...state, searchValue: payload };
    case actions.SET_SUGGESTIONS:
      return { ...state, suggestions: payload };
    case actions.SET_SUGGS_LOADING:
      return { ...state, isSuggestionsLoading: payload };
    case actions.SET_SUGGS_VISIBILITY:
      return { ...state, isSuggestionsShown: payload };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/routes/ProductSearch/reducer.ts